<template>
  <div class="modal" :class="{ 'is-active': isActive }">
    <div class="modal-background"></div>
    <div class="modal-card animated zoomIn faster">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ $t('modals.promotion.title') }}</p>
        <button class="delete" aria-label="close" @click="closeModal"></button>
      </header>
      <section class="modal-card-body">
        <div class="box-button promotion">
          <div v-if="temp" class="full-100">
            <div class="m-t-30 m-b-30 text-center">
              <div>
                {{ $t('modals.promotion.promo1Txt') }}
                <b>{{ temp.percentFail }}%</b>
                {{ $t('modals.promotion.promo2Txt') }}
                <span class="has-text-danger"
                  ><b>{{ $t('modals.promotion.promo3Txt') }}</b>
                </span>
                ***
              </div>
              <br />
              <div v-html="temp.description"></div>
            </div>
            <div class="box-button m-t-30">
              <button
                class="button full-100 is-primary"
                @click="handleActivate"
              >
                {{ $t('modals.promotion.receivePromoBtn') }}
              </button>
            </div>
          </div>
          <div v-else class="m-t-30 m-b-30 full-100 text-center">
            {{ notFound }}
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import apiPromotion from '@/api/promotion'
import i18n from '@/language'
export default {
  name: 'ModalPromotion',
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    promotion: {
      type: String
    }
  },
  data() {
    return {
      temp: undefined,
      notFound: i18n.t('modals.promotion.searchingMsg'),
      url: process.env.VUE_APP_BASE_API
    }
  },
  watch: {
    promotion: {
      immediate: true,
      async handler(val) {
        const prom = await apiPromotion.findPromotion(val.toUpperCase())
        if (prom) this.temp = prom
        else this.notFound = i18n.t('modals.promotion.promoNotFoundMsg')
      }
    }
  },
  methods: {
    closeModal() {
      this.$emit('closeModal', null)
    },
    handleActivate() {
      let loading = this.$loading.show()
      setTimeout(async () => {
        try {
          const prom = await apiPromotion.activatePromotion(
            this.promotion.toUpperCase()
          )
          if (prom) {
            this.$emit('closeModal', true)

            this.showSuccessAlert()
          }
        } catch (error) {
          this.showErrorAlert(error)
        } finally {
          loading.hide()
        }
      }, 200)
    },
    showSuccessAlert() {
      this.$swal(
        i18n.t('modals.successMsg'),
        i18n.t('modals.savedMsg'),
        'success'
      )
    },
    showErrorAlert(text) {
      this.$swal(i18n.t('modals.errorMsg'), text, 'error')
    }
  }
}
</script>

<style scoped lang="scss">
img {
  width: auto;
  height: 60px;
  margin-top: 20px;
  display: block;
  margin: 0 auto;
}

.modal-card-body {
  background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: cover;
}

.bonus {
  position: relative;
  border-radius: 10px;
  width: 100%;
  text-align: center;
  display: block;
  padding: 10px;
  margin-bottom: 20px;

  img {
    width: auto;
    height: 300px;
  }

  .description {
    margin-top: 30px;
    text-align: left;
    color: black;
  }
}

.promotion {
  // color: $primary;
  color: black;
}

.text-center {
  text-align: center;
}
</style>
